import React from "react";

const I360 = ({ style }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="42.354"
      height="31.214"
      viewBox="0 0 42.354 31.214"
      style={style}
      stroke="currentColor"
    >
      <g id="Raggruppa_599" transform="translate(-1319.482 -276.235)">
        <g id="Raggruppa_546" transform="translate(1227 226.118)">
          <text
            id="_360_"
            transform="translate(100.553 70.716)"
            fontSize="13"
            fontWeight="400"
          >
            <tspan x="0" y="0">
              360°
            </tspan>
          </text>
        </g>
        <g id="Raggruppa_597">
          <path
            id="Tracciato_136"
            d="M12,22.543A10.543,10.543,0,0,0,12,1.457"
            transform="translate(1338.293 279.492)"
            fill="none"
            strokeLinecap="round"
            strokeWidth="2"
          />
          <path
            id="Tracciato_137"
            d="M1.414,1.414l3.3,3.3,3.3-3.3"
            transform="translate(1343.195 276.235) rotate(90)"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
          <line
            id="Linea_158"
            y1="11.189"
            transform="translate(1350.293 280.948) rotate(90)"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
        </g>
        <g
          id="Raggruppa_598"
          transform="translate(2681.318 583.685) rotate(180)"
        >
          <path
            id="Tracciato_136-2"
            d="M12,22.543A10.543,10.543,0,0,0,12,1.457"
            transform="translate(1338.293 279.492)"
            fill="none"
            strokeLinecap="round"
            strokeWidth="2"
          />
          <path
            id="Tracciato_137-2"
            d="M1.414,1.414l3.3,3.3,3.3-3.3"
            transform="translate(1343.195 276.235) rotate(90)"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
          <line
            id="Linea_158-2"
            y1="11.189"
            transform="translate(1350.293 280.948) rotate(90)"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
        </g>
      </g>
    </svg>
  );
};

export default I360;
